<template>
  <article
    id="book-synopsis"
    class="book-synopsis d-book-synopsis"
  >
    <h5 class="space-bottom-2em">
      Synopsis
    </h5>

    <DExplicitOverlay
      v-if="containExplicit && contentIsHidden"
      button-text="Read synopsis"
      @button-click="showContent"
    />

    <div
      v-else
      class="large-font"
    >
      <slot name="synopsis" />
    </div>
  </article>
</template>

<script>
import DExplicitOverlay from '@d-components/d-explicit-overlay/d-explicit-overlay.vue';

export default {
  components: {
    DExplicitOverlay,
  },
  props: {
    containExplicit: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    contentIsHidden() {
      return this.$store.getters['ExplicitContent/get-hidden-content'].synopsis;
    },
  },
  methods: {
    showContent() {
      this.$store.dispatch('ExplicitContent/setSynopsisVisibility', false);
    },
  },
};
</script>
